<script>
    import app from "../stores/app";
    import {copyObject, setFocusTo, trim} from "../lib/lib";
    import {ROUTE_TYPE} from "../lib/constants";
    import Modal from '../components/modal/Modal.svelte';
    import OfferLocations from "./OfferLocations.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import Notifier from "../stores/notifier";
    import PriceControl from "../components/controls/PriceControl.svelte";

    export let route;
    export let locations;
    export let tours;
    export let department_id;
    export let onClose = () => {
    };

    let pickupFromDepartmentHotels = 0;
    let dropToDepartmentHotels = 0;
    let pickups;
    let destinations;
    let newRoute = route.route_type == null;
    let vehicles = [];

    const save = () => {
        if (pickupFromDepartmentHotels == 1) {
            route.pickups = 'department';
        } else {
            route.pickups = pickups;
        }

        if (dropToDepartmentHotels == 1) {
            route.destinations = 'department';
        } else {
            route.destinations = destinations;
        }

        if (route.route_type == ROUTE_TYPE.TOUR) {
            route.destinations = [];
            let tour = tours.find(x => x.id == route.tour_id);
            if (tour) {
                route.title = tour.name;
            }

            if (!route.tour_id) {
                Notifier.showError("Select a tour for this route!");
                setFocusTo("routeTour");
                return;
            }
        } else {
            route.allow_schedule_date = 1;
        }

        route.title = trim(route.title);
        if (!route.title) {
            Notifier.showError("Enter a title for this route!");
            setFocusTo("routeTitle");
            return;
        }

        route.prices = [];
        vehicles.map(item => {
            if (Number(item.price) > 0) {
                route.prices.push({id: item.id, price: item.price});
            }
        });

        onClose(route);
    }

    const close = () => {
        onClose();
    }

    if (route.pickups === 'department') {
        pickupFromDepartmentHotels = 1;
        pickups = [];
    } else {
        pickups = route.pickups;
    }

    if (route.destinations === 'department') {
        dropToDepartmentHotels = 1;
        destinations = [];
    } else {
        destinations = route.destinations;
    }

    if (!route.prices) {
        route.prices = [];
    }
    $app.vehicle_types.map(item => {
        let vehicle = route.prices.find(x => x.id == item.id);
        if (!vehicle) {
            vehicle = {id: item.id, name: item.name, price: 0};
        } else {
            vehicle.name = item.name;
        }
        vehicles.push(vehicle);
    });
</script>

<Modal modalSm title="Route details" on:close={close}>
    <div slot="body">
        {#if route.route_type == null}
            <div class="form-group">
                <select class="form-select" bind:value={route.route_type}>
                    <option value={null}>select route type</option>
                    <option value={ROUTE_TYPE.TRANSFER}>Transfer</option>
                    <option value={ROUTE_TYPE.TOUR}>Tour</option>
                </select>
            </div>
        {/if}

        {#if route.route_type == ROUTE_TYPE.TRANSFER}
            <div class="mb-4">
                <div class="legend mb-2">Title</div>
                <input type="text" class="form-control" id="routeTitle" bind:value={route.title}>
            </div>
            <div class="mb-4">
                <div class="legend mb-2">
                    Pickup locations
                    <Checkbox label="Department hotels" bind:checked={pickupFromDepartmentHotels}/>
                </div>
                {#if pickupFromDepartmentHotels == 0}
                    <OfferLocations bind:value={pickups} {locations} {department_id}/>
                {/if}
            </div>
            <div class="mb-4">
                <div class="legend mb-2">
                    Destinations
                    <Checkbox label="Department hotels" bind:checked={dropToDepartmentHotels}/>
                </div>
                {#if dropToDepartmentHotels == 0}
                    <OfferLocations bind:value={destinations} {locations} {department_id}/>
                {/if}
            </div>
        {/if}

        {#if route.route_type == ROUTE_TYPE.TOUR}
            <div class="mb-4">
                <div class="legend mb-2">Tour</div>
                <select class="form-select" id="routeTour" bind:value={route.tour_id}>
                    {#if newRoute}
                        <option value={null}>select tour to add</option>
                    {/if}
                    {#each tours as tour}
                        <option value={tour.id}>{tour.name}</option>
                    {/each}
                </select>
            </div>
            <div class="mb-4">
                <div class="legend mb-2">
                    Pickup locations
                    <Checkbox label="Department hotels" bind:checked={pickupFromDepartmentHotels}/>
                </div>
                {#if pickupFromDepartmentHotels == 0}
                    <OfferLocations bind:value={pickups} {locations} {department_id}/>
                {/if}
            </div>
            <div class="mb-4">
                <Checkbox label="Allow tour schedule" bind:checked={route.allow_schedule_date}/>
            </div>
        {/if}

        <div class="mb-4">
            <div class="legend mb-2">Prices</div>
            <div class="d-flex flex-wrap gap-3">
                {#each vehicles as vehicle}
                    <div class="price-item">
                        <div class="smaller text-dark text-truncate" title={vehicle.name}>{vehicle.name}</div>
                        <PriceControl bind:value={vehicle.price} cssClass="form-control-sm" warnOnEmpty/>
                    </div>
                {/each}
            </div>
        </div>

        <hr>
        <div class="text-end">
            <button class="btn btn-link me-2" on:click={() => close()}>Close</button>
            {#if route.route_type != null}
                <button class="btn btn-primary px-4" on:click={save}>Save</button>
            {/if}
        </div>
    </div>
</Modal>

<style>
    .price-item {
        width: calc(20% - 13px);
    }
</style>